import { ReactNode } from "react";
import styles from "./SheetTop.module.css";

type SheetTopProps = {
  children: ReactNode;
  className?: string | undefined;
};

function SheetTop({ children, className }: SheetTopProps) {
  const combinedClassName = className
    ? `${styles["root"]} ${className}`
    : styles["root"];

  return <div className={combinedClassName}>{children}</div>;
}

export default SheetTop;
